import React, { useContext } from 'react';
import './NeedHelpPage.scss';
import { useNavigate } from 'react-router-dom';
import { SiteContext } from '../../../context/SiteContext';
import { ButtonBack } from '../../common/Button/ButtonBack';

const MyAccountAncillaryPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { site } = useContext(SiteContext);
  const { brand } = site;
  const brandPhoneNumber = brand.brandPhoneNumbers.quotesAndRenewalsNumber;

  const goBack = (): void => {
    navigate(-1);
  };

  return (
    <div>
      <p>
        My account is not available, please call us on
        <a className='in-text' href={`tel:${brandPhoneNumber}`}>
          {brandPhoneNumber}
        </a>{' '}
      </p>
      <div className='flex-row form-nav'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={goBack}
          additionalClassNames='btn-back'
        />
      </div>
    </div>
  );
};
export default MyAccountAncillaryPage;
